import * as React from 'react';
import { observer } from 'mobx-react';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { connectedAccountsStore } from '../store/store';
import { updateBasicIsConnecting } from '../actions/connectBasic/updateBasicIsConnecting';
import { updateBasicAdvancedChecked } from '../actions/connectBasic/updateBasicAdvancedChecked';
import { updateBasicDisplayName } from '../actions/connectBasic/updateBasicDisplayName';
import { updateBasicEmailAddress } from '../actions/connectBasic/updateBasicEmailAddress';
import { updateBasicPassword } from '../actions/connectBasic/updateBasicPassword';
import { updateBasicUseNewFolder } from '../actions/connectBasic/updateBasicUseNewFolder';
import { toggleConnectBasicWindow } from '../actions/connectBasic/toggleConnectBasicWindow';
import { newSyncRequest } from '../services/newSyncRequest';
import { initConnectedAccountsFull } from '../orchestrators/initConnectedAccountsFull';
import { toggleConnectAdvancedWindow } from '../actions/connectAdvanced/toggleConnectAdvancedWindow';
import { resetConnectAdvancedStore } from '../actions/connectAdvanced/resetConnectAdvancedStore';
import strings from 'owa-strings/owa-options-strings';
import { getErrorConnectBasic } from '../selectors/getErrorConnectBasic';
import IncomingAccountInformation from './IncomingAccountInformation';

const styles = require('./ConnectBasicWindow.scss');

@observer
export default class ConnectBasicWindow extends React.Component<{}, {}> {
    private onConnect = () => {
        let store = connectedAccountsStore();

        if (store.connectBasicState.advancedChecked) {
            toggleConnectBasicWindow({ connectBasicOpen: false });
            resetConnectAdvancedStore(
                store.connectBasicState.displayName,
                store.connectBasicState.emailAddress,
                store.connectBasicState.password,
                store.connectBasicState.useNewFolder
            );
            toggleConnectAdvancedWindow({ connectAdvancedOpen: true });
        } else {
            updateBasicIsConnecting(true);

            newSyncRequest({
                DisplayName:
                    store.connectBasicState.displayName || store.connectBasicState.emailAddress,
                Name: store.connectBasicState.emailAddress,
                EmailAddress: store.connectBasicState.emailAddress,
                TargetRootFolder: store.connectBasicState.useNewFolder
                    ? store.connectBasicState.emailAddress
                    : undefined,
                IncomingPassword: store.connectBasicState.password,
            }).then(response => {
                updateBasicIsConnecting(false);
                toggleConnectBasicWindow({ connectBasicOpen: false });
                if (!response.ErrorMessage) {
                    initConnectedAccountsFull();
                } else {
                    resetConnectAdvancedStore(
                        store.connectBasicState.displayName,
                        store.connectBasicState.emailAddress,
                        store.connectBasicState.password,
                        store.connectBasicState.useNewFolder,
                        response.ErrorMessage
                    );
                    toggleConnectAdvancedWindow({ connectAdvancedOpen: true });
                }
            });
        }
    };

    private onClose = () => {
        toggleConnectBasicWindow({ connectBasicOpen: false });
    };

    private onAdvancedSettingsChecked = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) => {
        updateBasicAdvancedChecked(checked);
    };

    render() {
        let store = connectedAccountsStore();

        return (
            <Dialog
                hidden={!store.dialogWindowState.connectBasicOpen}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: strings.options_connected_basic_title,
                }}
                modalProps={{
                    isBlocking: true,
                    containerClassName: styles.dialog,
                    onDismiss: this.onClose,
                }}>
                <IncomingAccountInformation
                    useNewFolder={store.connectBasicState.useNewFolder}
                    disableEmailAddress={false}
                    renderUserNameContent={false}
                    renderNewFolderContent={true}
                    isBasicAuth={true}
                    onUpdateDisplayName={updateBasicDisplayName}
                    onUpdateEmailAddress={updateBasicEmailAddress}
                    onUpdatePassword={updateBasicPassword}
                    onUpdateUseNewFolder={updateBasicUseNewFolder}
                />
                <Label className={styles.advanced}>
                    {strings.options_connected_basic_advancedSettingsLabel}
                </Label>
                <Checkbox
                    className={styles.checkbox}
                    label={strings.options_connected_basic_manualConfigCheckbox}
                    defaultChecked={false}
                    onChange={this.onAdvancedSettingsChecked}
                />
                <DialogFooter>
                    {store.connectBasicState.isConnecting && (
                        <Spinner size={SpinnerSize.large} className={styles.spinner} />
                    )}
                    <PrimaryButton
                        onClick={this.onConnect}
                        disabled={getErrorConnectBasic() || store.connectBasicState.isConnecting}>
                        {strings.options_connected_okButton}
                    </PrimaryButton>
                    <DefaultButton
                        onClick={this.onClose}
                        disabled={store.connectBasicState.isConnecting}>
                        {strings.options_connected_cancelButton}
                    </DefaultButton>
                </DialogFooter>
            </Dialog>
        );
    }
}
